const dashboard_wrapper = {
	otp_not_enabled_dialog: {
		button: "2FA aktivieren",
		description:
			"Diese Seite erfordert eine zweistufige Verifizierung (2FA). Bitte aktiviere sie, bevor du fortfährst.",
		title: "Zweistufige Verifizierung (2FA) nicht aktiviert",
	},
	otp_required_dialog: {
		description:
			"Diese Seite erfordert eine zweistufige Verifizierung (2FA). Gib deinen 2FA-Code ein, bevor du fortfährst.",
		title: "Zweistufige Verifizierung (2FA) erforderlich!",
	},
	paid_services_disabled: {
		description:
			"Sie sind nur für Unternehmen und niederländische Staatsbürger verfügbar. Wenn Sie glauben, dass dies nicht auf Sie zutrifft, lassen Sie es uns bitte wissen. Wenn Sie kein niederländischer Staatsbürger sind, können wir möglicherweise ein Unternehmen in Ihrem Land finden, das unsere Dienstleistungen anbietet.",
		title: "Bezahlte Dienste sind für Sie deaktiviert.",
	},
};

export default dashboard_wrapper;
